import { Component, OnInit, DestroyRef } from '@angular/core';
import { ChartDataset } from 'chart.js';

import { Subject } from 'rxjs';
import { DashboardService } from '@app/dashboard/services/dashboard.service';
import { ToArabicPipe } from '@app/shared/pipes/toArabic.pipe';
import { map } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { SHARED_IMPORTS } from '@app/shared/shared.imports';
import { BaseChartDirective } from 'ng2-charts';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslateModule } from '@ngx-translate/core';
import { LanguageService } from '@app/core';

@Component({
  selector: 'app-dashboard-chart4',
  templateUrl: './dashboard-chart4.component.html',
  styleUrls: ['./dashboard-chart4.component.scss'],
  standalone: true,
  imports: [...SHARED_IMPORTS, CommonModule, BaseChartDirective, TranslateModule]
})
export class DashboardChart4Component implements OnInit {
  loaded: boolean;
  lineChartPlugins: any[] = [];
  lineChartData: ChartDataset[] = [
    {
      //data set
      data: [],
      //label name
      label: 'نفايات',
      //to make line sharp not curvied
      tension: 0,
      // line border thick
      borderWidth: 2,
      // related with box label
      fill: false,
      yAxisID: 'A'

      //dashed border line
      // borderDash: [10, 5]
    },
    {
      data: [],
      label: ' مركبات',
      tension: 0,
      borderWidth: 2,
      fill: false,
      yAxisID: 'A'
      // borderDash: [10, 5]
    }
  ];

  lineChartLabels: string[] = [];
  lineChartOptions = {};

  lineChartColors: any = [
    //first dataset colors
    {
      borderColor: '#1676B7',
      backgroundColor: 'transparent',
      pointBackgroundColor: '#1676B7'
    },
    //second data set colors
    {
      borderColor: '#FF0000',
      backgroundColor: 'transparent',
      pointBackgroundColor: '#FF0000'
    }
  ];

  lineChartLegend = false;
  lineChartType = 'line';
  constructor(
    private service: DashboardService,
    private toArabic: ToArabicPipe,
    private languageService: LanguageService,
    private destroyRef: DestroyRef
  ) {}

  ngOnInit() {
    this.setOptions();
    this.getData();
  }
  getData() {
    this.service
      .getData('today-weights-count-per-hour')
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        map((data: any) => data.data),
        map((data: any) => this.refactorResponse(data))
      )
      .subscribe((response: any) => {
        this.lineChartLabels = response.map((data: any) => data['hour']).reverse();
        this.lineChartData[0]['data'] = response.map((data: any) => data['total_weights']).reverse();
        this.lineChartData[1]['data'] = response.map((data: any) => data['total_units']).reverse();
        this.loaded = true;
      });
  }
  refactorResponse = (response: any) => {
    response.forEach((element: any) => {
      element['hour'] = this.toArabic.transform(element['hour'].toString()) + ':' + this.toArabic.transform('00');
    });
    return response;
  };

  setOptions() {
    return (this.lineChartOptions = {
      responsive: true,
      showTooltips: true,
      tooltips: {
        backgroundColor: '#2981BD',
        titleAlign: 'center',
        titleFontSize: 18,
        titleFontFamily: 'Helvetica',
        yPadding: 0,
        xPadding: 6,
        custom: function(tooltip: any) {
          // console.log('custom tooltip', tooltip);
          //change background color on hover on tooltip
          if (tooltip['dataPoints']) {
            tooltip['backgroundColor'] = tooltip['dataPoints'][0]['datasetIndex'] ? ' #FF0000' : '#1676B7';
          }
          //hide body tooltip
          tooltip.body = [];
        },
        callbacks: {
          // We'll edit the `title` string
          title: function(tooltipItem: any) {
            // console.log("this", this);
            // console.log("tooltipItem", tooltipItem);
            let toArabic = new ToArabicPipe();
            return `
${this._data.labels[tooltipItem[0].index]}

${tooltipItem[0].datasetIndex ? 'عدد : ' : 'وزن : '}${toArabic.transform(tooltipItem[0].yLabel.toString())} ${
              tooltipItem[0].datasetIndex ? 'مركبة' : 'طن'
            }`;
          }
        }
      },

      //remove all dots from lines
      elements: {
        point: {
          radius: 2
        }
      },
      //position label box
      legend: {
        // box label width
        labels: {
          boxWidth: 15,
          fontSize: 18
        },
        position: 'left'
      },
      //hide data from line
      plugins: {
        datalabels: {
          display: false
        }
      },

      //hide data from xaxis and y axis
      scales: {
        A: {
          position: 'right'
          // ticks: {
          //   display: false
          // }
        },
        x: {
          ticks: {
            autoSkip: false
          }
        }
      }
    });
  }
  get isEnglish(): boolean {
    return this.languageService.isEnglish;
  }
}
